import React, { useEffect, useState } from 'react';
import {
    ChevronDownIcon,
    Menu,
    Box,
    Pressable,
    VStack,
} from 'native-base';
import {
    GIFTCARD_FLOWS,
    GiftCardPayment,
    observer,
    useGetGiftCardPaymentList,
    useSpringBigStore,
    i18nFn, useTheme,
} from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { Input, Button } from '~/shared/Theme';

const PaymentDropdown = ({
    paymentMethod,
    setPaymentMethod,
    t }: {
        paymentMethod: GiftCardPayment | null,
        setPaymentMethod: React.Dispatch<React.SetStateAction<GiftCardPayment | null>>
        t: i18nFn
    }) => {


    const {
        primary,
        radius_md,
        modal,
        modal_text,
    } = useTheme();

    const [isOpen, setMenuOpen] = useState(false);

    const { giftCardPaymentList } = useSpringBigStore();
    const giftCardPaymentListQuery = useGetGiftCardPaymentList();

    useEffect(() => {

        giftCardPaymentListQuery?.refetch();
    }, []);

    const paymentCards = giftCardPaymentList?.filter(
        (payment: GiftCardPayment) => payment.card_nickname
    );

    const onPayemendAddPress = () => {

        observer.emit('change-screen', GIFTCARD_FLOWS.addPayment);
    };

    const handlePress = () => {

        setMenuOpen(!isOpen);
    };

    const onManagePaymentPress = () => {

        observer.emit('change-screen', GIFTCARD_FLOWS.managePayment);
    };

    return (
        <Input
            keyboardType="numeric"
            placeholder={t('giftCard.field.method')}
            value={
                paymentMethod &&
                    (paymentMethod.account_name ||
                        paymentMethod.card_nickname) || t('giftCard.field.method')
            }
            isDisabled
            InputRightElement={
                <Menu
                    isOpen={isOpen}
                    onOpen={() => handlePress()}
                    onClose={() => handlePress()}
                    placement={'bottom'}
                    background={modal}
                    color={modal_text}
                    rounded={radius_md}
                    p={0}
                    defaultIsOpen={false}
                    trigger={(triggerProps) => {

                        return (
                            <Pressable
                                accessibilityLabel={'More options menu'}
                                {...triggerProps}
                            >
                                <ChevronDownIcon
                                    color={primary}
                                    size={'lg'}
                                    px={2}
                                />
                            </Pressable>
                        );
                    }}
                >
                    <VStack space={4}>
                        { paymentCards ?
                            <PaymentMethodMapper
                                paymentMethods={paymentCards}
                                setPaymentMethod={setPaymentMethod}
                            />
                            :
                            <></>
                        }
                        {/* {paymentChecks && (
                            <PaymentMethodMapper
                                paymentMethods={paymentChecks}
                                setPaymentMethod={setPaymentMethod}
                                title="bank account"
                            />
                        )} */}
                        <Button
                            text={'giftCard.plus_payment'}
                            onPress={onPayemendAddPress}
                        />
                        <Button
                            text={'payment.manage'}
                            onPress={onManagePaymentPress}
                        />
                    </VStack>
                </Menu>
            }
        />
    );
};

const PaymentMethodMapper = ({
    paymentMethods,
    setPaymentMethod,
}: {
    paymentMethods: GiftCardPayment[];
    setPaymentMethod: (method: GiftCardPayment) => void;
}) => {

    const { primary } = useTheme();

    return (
        <>
            {
                paymentMethods &&
                paymentMethods.length > 0 &&
                <Box
                    borderBottomColor={primary}
                    borderBottomWidth={3}
                >
                    <Caption
                        text={'giftCard.cards'}
                        textAlign={'center'}
                        fontSize={18}
                        color={primary}
                    />
                </Box>
            }
            {
                paymentMethods &&
                paymentMethods.length > 0 &&
                paymentMethods.map((paymentMethod) => {

                    const { account_name, card_nickname } = paymentMethod;

                    return (
                        <Menu.Item
                            key={`${account_name || card_nickname}-${Math.random()}`}
                            backgroundColor={'transparent'}
                            padding={0}
                        >
                            <Pressable
                                w={'100%'}
                                textAlign={'center'}
                                py={2}
                                onPress={() => setPaymentMethod(paymentMethod)}
                            >
                                <Caption fontSize={22} fontWeight={'200'}>
                                    x{ account_name || card_nickname }
                                </Caption>
                            </Pressable>
                        </Menu.Item>
                    );
                })
            }
        </>
    );
};

export default PaymentDropdown;
